<template>
  <div class="px-6 py-6 overflow-y-auto">
    <div class="pb-4 border-b border-gray-300">
      <h1 class="text-2xl font-semibold text-gray-900">
        ข้อมูลลูกค้า (บริษัท)
      </h1>
      <p>รายละเอียดข้อมูลของลูกค้า สมัครใช้ระบบในนามบริษัท</p>
    </div>

    <!-- Error Message -->
    <div
      v-if="errors.length > 0"
      class="px-4 py-3 rounded-md bg-red-600 bg-opacity-20 flex items-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-red-600"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>
      <p class="text-base font-semibold text-red-800 flex-1 px-3">
        {{ errors[0] }}
      </p>
      <button @click="errors = []" type="button" class="focus:outline-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-red-600"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
    <!-- End Error Message -->

    <ValidationObserver v-slot="{ invalid }">
      <div class="divide-y divide-gray-300">
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >รหัสบริษัทลูกค้า<span class="text-xl text-red-600">*</span></label
          >
          <div class="col-span-2 max-w-lg">
            <ValidationProvider
              name="รหัสบริษัทลูกค้า"
              rules="required"
              v-slot="{ errors }"
            >
              <input
                v-model.trim="customer.company_code"
                type="text"
                class="
                  leading-none
                  focus:ring-cyan-500 focus:border-cyan-500
                  block
                  w-full
                  shadow-sm
                  border-gray-300
                  rounded-md
                "
              />
              <span class="text-base text-red-600">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >ชื่อบริษัทลูกค้า (ไทย)<span class="text-xl text-red-600"
              >*</span
            ></label
          >
          <div class="col-span-2 max-w-lg">
            <ValidationProvider
              name="ชื่อบริษัทลูกค้า (ไทย)"
              rules="required"
              v-slot="{ errors }"
            >
              <input
                v-model="customer.title_th"
                type="text"
                class="
                  leading-none
                  focus:ring-cyan-500 focus:border-cyan-500
                  block
                  w-full
                  shadow-sm
                  border-gray-300
                  rounded-md
                "
              />
              <span class="text-base text-red-600">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >ชื่อบริษัทลูกค้า (อังกฤษ)<span class="text-xl text-red-600"
              >*</span
            ></label
          >
          <div class="col-span-2 max-w-lg">
            <ValidationProvider
              name="ชื่อบริษัทลูกค้า (อังกฤษ)"
              rules="required"
              v-slot="{ errors }"
            >
              <input
                v-model="customer.title_en"
                type="text"
                class="
                  leading-none
                  focus:ring-cyan-500 focus:border-cyan-500
                  block
                  w-full
                  shadow-sm
                  border-gray-300
                  rounded-md
                "
              />
              <span class="text-base text-red-600">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >ที่อยู่ (ไทย)</label
          >
          <textarea
            v-model="customer.address_th"
            rows="3"
            class="
              col-span-2
              max-w-lg
              shadow-sm
              focus:ring-cyan-500 focus:border-cyan-500
              block
              w-full
              border border-gray-300
              rounded-md
            "
          ></textarea>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >ที่อยู่ (อังกฤษ)</label
          >
          <textarea
            v-model="customer.address_en"
            rows="3"
            class="
              col-span-2
              max-w-lg
              shadow-sm
              focus:ring-cyan-500 focus:border-cyan-500
              block
              w-full
              border border-gray-300
              rounded-md
            "
          ></textarea>
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700">เว็บไซต์</label>
          <input
            v-model="customer.www"
            type="text"
            class="
              leading-none
              col-span-2
              max-w-lg
              focus:ring-cyan-500 focus:border-cyan-500
              block
              w-full
              shadow-sm
              border-gray-300
              rounded-md
            "
            placeholder="https://domain.co.th"
          />
        </div>
        <div class="py-4 grid grid-cols-4">
          <label class="text-base font-medium text-gray-700"
            >ใส่โน็ตเพิ่มเติม</label
          >
          <textarea
            v-model="customer.note"
            rows="3"
            class="
              col-span-2
              max-w-lg
              shadow-sm
              focus:ring-cyan-500 focus:border-cyan-500
              block
              w-full
              border border-gray-300
              rounded-md
            "
          ></textarea>
        </div>
        <div class="py-4 grid grid-cols-4">
          <div class="col-start-2 col-span-2">
            <button
              @click="onSave"
              :disabled="loading || invalid"
              :class="{ 'cursor-not-allowed': loading || invalid }"
              type="button"
              class="
                w-full
                inline-flex
                justify-center
                rounded-md
                border border-transparent
                shadow-sm
                px-4
                py-2
                bg-cyan-600
                text-base
                font-medium
                text-white
                hover:bg-cyan-700
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-cyan-500
                sm:w-auto
              "
            >
              <svg
                v-if="loading"
                class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              บันทึกการเปลี่ยนแปลง
            </button>
            <button
              @click="onCancel"
              :disabled="loading"
              :class="{ 'cursor-not-allowed': loading }"
              type="button"
              class="
                w-full
                inline-flex
                justify-center
                rounded-md
                border border-gray-300
                shadow-sm
                px-4
                py-2
                bg-white
                text-base
                font-medium
                text-gray-700
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-cyan-500
                sm:ml-3 sm:w-auto
              "
            >
              ยกเลิก
            </button>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <!-- confirm leave page -->
    <AppConfirmLeavePageModal
      :show="isConfirmLeavePageShow"
      :next="isConfirmLeavePageNextFunction"
      @cancel="onCancelConfirmLeavePage"
      @submit="onSubmitConfirmLeavePage"
    />
    <!-- end confirm leave page -->
  </div>
</template>

<script>
import AppConfirmLeavePageModal from '@/components/AppConfirmLeavePageModal'
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

// No message specified.
// extend('required', required)

// Override the default message.
extend('required', {
  ...required,
  message: 'จำเป็นต้องระบุ {_field_}',
})

export default {
  name: 'CustomerDetails',

  components: {
    AppConfirmLeavePageModal,
  },

  data() {
    return {
      loading: false,
      currentCustomer: {},
      customer: {},
      errors: [],
      timeout: null,
      isConfirmLeavePageShow: false,
      isConfirmLeavePageNextFunction: null,
    }
  },

  computed: {
    isDataChange() {
      if (
        this.currentCustomer.company_code !== this.customer.company_code ||
        this.currentCustomer.title_th !== this.customer.title_th ||
        this.currentCustomer.title_en !== this.customer.title_en ||
        this.currentCustomer.address_th !== this.customer.address_th ||
        this.currentCustomer.address_en !== this.customer.address_en ||
        this.currentCustomer.www !== this.customer.www ||
        this.currentCustomer.note !== this.customer.note
      ) {
        return true
      }
      return false
    },
  },

  created() {
    this.$store.commit('setMenusCustomerActive', true)

    const uuid = this.$route.params.uuid
    this.fetchCustomer(uuid)
  },

  methods: {
    onCancelConfirmLeavePage() {
      this.isConfirmLeavePageShow = false

      this.errors = []
    },

    onSubmitConfirmLeavePage(obj) {
      this.isConfirmLeavePageShow = false
      this.timeout = setTimeout(() => {
        obj.next()
      }, 200)
      return
    },

    async fetchCustomer(uuid) {
      try {
        this.loading = true

        const customer = await this.$store.dispatch(
          'customer/fetchCustomer',
          uuid
        )

        this.$store.commit('setBreadcrumbs', [
          { text: 'รายชื่อลูกค้า', routeName: 'CustomerList' },
          {
            text: customer.title_th || 'ลูกค้า',
            routeName: 'CustomerDetails',
          },
        ])

        this.currentCustomer = {
          company_uuid: customer.company_uuid,
          company_code: customer.company_code,
          title_th: customer.title_th,
          title_en: customer.title_en,
          address_th: customer.address_th || '',
          address_en: customer.address_en || '',
          www: customer.www || '',
          note: customer.note || '',
        }
        this.customer = {
          company_uuid: customer.company_uuid,
          company_code: customer.company_code,
          title_th: customer.title_th,
          title_en: customer.title_en,
          address_th: customer.address_th || '',
          address_en: customer.address_en || '',
          www: customer.www || '',
          note: customer.note || '',
        }
      } catch (error) {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching customer',
        }
        this.$store.dispatch('notification/add', notification)
        console.log(error.response)
      } finally {
        this.loading = false
      }
    },

    onCancel() {
      const uuid = this.$route.params.uuid
      this.fetchCustomer(uuid)

      this.errors = []
    },

    async onSave() {
      this.errors = []

      try {
        const customerUpdate = {
          company_uuid: this.customer.company_uuid,
          company_code: this.customer.company_code,
          title_th: this.customer.title_th,
          title_en: this.customer.title_en,
          address_th: this.customer.address_th || null,
          address_en: this.customer.address_en || null,
          www: this.customer.www || null,
          note: this.customer.note || null,
        }

        this.loading = true

        await this.$store.dispatch('customer/editCustomer', customerUpdate)

        const notification = {
          type: 'success',
          message: 'Your customer has been updated!',
        }
        this.$store.dispatch('notification/add', notification)

        this.currentCustomer = {
          company_uuid: customerUpdate.company_uuid,
          company_code: customerUpdate.company_code,
          title_th: customerUpdate.title_th,
          title_en: customerUpdate.title_en,
          address_th: customerUpdate.address_th || '',
          address_en: customerUpdate.address_en || '',
          www: customerUpdate.www || '',
          note: customerUpdate.note || '',
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors.push(
            error.response.data.message || 'Something went wrong.'
          )
        }

        console.log(error.response)
      } finally {
        this.loading = false
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDataChange) {
      this.isConfirmLeavePageShow = true
      this.isConfirmLeavePageNextFunction = next
      return
    }

    next()
  },
}
</script>
